import { globalFetch } from "foundation/js/api"

export default {
    namespaced: true,
    state: {
        submitting: false,
        lottery_ticket: {
            id: "",
            isWinningTicket: false,
            prize: 0,
        }
    },
    mutations: {
        SET_IS_SUBMITTING(state, object){
            state.submitting = object
        },
        SET_LOTTERY_ROUNDS(state, object){
            state.lottery_rounds = object
        },
        SET_LOTTERY_TICKET(state, object){
            state.lottery_ticket = object
        }
    },
    getters: {

    },
    actions: {
        async getLotteryTicketResult(context, config){
            const url = `${document.location.origin}`
                + `/${process.env.LOTTERY_GET_RESULT}`
                .replace('[lotteryTicketId]', config.lotteryTicketId)
                .replace('[roundNumber]', config.roundNumber)

            context.commit("SET_IS_SUBMITTING", true)

            return await globalFetch(url)
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }

                    throw new Error(response.error)
                })
                .then((json) => {
                    context.commit("SET_IS_SUBMITTING", false)
                    context.commit('SET_LOTTERY_TICKET', json)
                })
                .catch((error) => {
                    context.commit("SET_IS_SUBMITTING", false)

                    throw error
                })
        }        
    }

}
